import { render, staticRenderFns } from "./GooglePlay.vue?vue&type=template&id=4356b32d&scoped=true"
import script from "./GooglePlay.vue?vue&type=script&lang=js"
export * from "./GooglePlay.vue?vue&type=script&lang=js"
import style0 from "./GooglePlay.vue?vue&type=style&index=0&id=4356b32d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4356b32d",
  null
  
)

export default component.exports